import { create } from "zustand";
import { persist } from "zustand/middleware";
import { CurrencyOption } from "./useCurrencies";

interface CurrencySelectorStore {
  selectedCurrency: CurrencyOption | null;
  setSelectedCurrency: (currency: CurrencyOption | null) => void;
}

const useCurrencyStore = create<CurrencySelectorStore>()(
  persist(
    (set) => ({
      selectedCurrency: null,
      setSelectedCurrency: (currency) => set({ selectedCurrency: currency }),
    }),
    {
      name: "beunderwater-currency",
    }
  )
);

export default useCurrencyStore;


